import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { EXPIRATION_PROMOTIONS_PATH } from '../../core/constants';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getProductExpirationPromotionsAction = createAsyncThunk(
    'price/getProductExpirationPromotionsAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ EXPIRATION_PROMOTIONS_PATH }/product/${ data.productId }${ buildQueryString(data.queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductExpirationPromotionsSlice = createSlice({
    name: 'getProductExpirationPromotionsSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateProductExpirationPromotions() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getProductExpirationPromotionsAction.pending, () => STATE__API__STARTED);
        builder.addCase(getProductExpirationPromotionsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductExpirationPromotionsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateProductExpirationPromotions } = getProductExpirationPromotionsSlice.actions;
export const getProductExpirationPromotionsState = (state) => state.price.getProductExpirationPromotions;
export default getProductExpirationPromotionsSlice.reducer;